import React from 'react';

const legalData = {
  editor: {
    name: "Clément Bourga",
    activity: "Cabinet de conseil",
    address: "40 Rue Romain Rolland, 31520 Ramonville-Saint-Agne",
    email: "clement.bourga at kedgebs.com",
    siret: "878 622 711 00033",
    vat: "FR39878622711",
    rcs: "RCS Toulouse 878622711",
  },
  host: {
    name: "OVH",
    address: "2 Rue Kellermann, 59100 Roubaix, France",
    phone: "+33 9 72 10 10 07",
    siret: "424 761 419 00045",
  },
};

const LegalSection = ({ title, children }) => (
  <section className="legal-section">
    <h2>{title}</h2>
    {children}
  </section>
);

const MentionsLegales = () => {
  return (
    <div className="legal-page">
      <h1>Mentions Légales</h1>

      <LegalSection title="1. Éditeur du site">
        <p>
          {legalData.editor.name} ({legalData.editor.activity})<br />
          Adresse : {legalData.editor.address}<br />
          Email : {legalData.editor.email}<br />
          SIRET : {legalData.editor.siret}<br />
          TVA intracommunautaire : {legalData.editor.vat}<br />
          RCS : {legalData.editor.rcs}
        </p>
      </LegalSection>

      <LegalSection title="2. Directeur de la publication">
        <p>{legalData.editor.name}</p>
      </LegalSection>

      <LegalSection title="3. Hébergeur">
        <p>
          {legalData.host.name} (SIRET : {legalData.host.siret})<br />
          Adresse : {legalData.host.address}<br />
          Téléphone : {legalData.host.phone}<br />
          <a href="https://www.ovh.com/fr/mentions-legales/" target="_blank" rel="noopener noreferrer">
            Mentions légales de l’hébergeur
          </a>
        </p>
      </LegalSection>

      <LegalSection title="4. Données personnelles">
        <p>
          Les données collectées sont traitées par {legalData.editor.name} pour gérer vos demandes.
          Durée de conservation : 3 ans. Pour exercer vos droits (accès, suppression), contactez-nous à {legalData.editor.email}.
          <a href="/politique-confidentialite"> En savoir plus</a>.
        </p>
      </LegalSection>

      {/* Ajoute les autres sections ici */}
    </div>
  );
};

export default MentionsLegales;
